import React, { useState } from "react";
import { MenuList, MenuItem } from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";

import Btn from "components/Custom/Btn";

// Reports
import Report1 from "../Report1";

import ReportUserLog from "./ReportUserLog";
import ReportEmployeeLeaves from "./ReportEmployeeLeaves";
import CustomerOrders from "./CustomerOrders";
import AllLogsReport from "./AllLogsReport";
import UserLogReport from "./UserLogReport";
import RouteList from "./RouteList";
import PriceList from "./PriceList";
import ProductList from "./ProductList";
import LeadsReport from "./LeadsReport";
import FeedbackReport from "./FeedbackReport";
import InstructionsReport from "./InstructionsReport";
import SurveyReport from "./SurveyReport";
import CustomerList from "./CustomerList";
import LeavesReport from "./LeavesReport";
import AttendanceReport from "./AttendanceReport";
import CitiesListReport from "./CitiesListReport";
import TeamDetailReport from "./TeamDetailReport";
import RouteReport from "./RouteReport";

import BeatOrderReport from "./BeatOrderReport";
import OrderDetailReport from "./OrderDetailReport";
import SchemeReport from "./SchemeReport";
import SchemeUtilizationReport from "./SchemeUtilizationReport";
import TargetReport from "./TargetReport";
import TargetStatusReport from "./TargetStatusReport";
import TargetTotalReport from "./TargetTotalReport";
import CategorySaleReport from "./CategorySaleReport";
import MainCategoryWiseSaleReport from "./MainCategoryWiseSaleReport";
import SubCategoryWiseSaleReport from "./SubCategoryWiseSaleReport";
import SkuWiseSaleReport from "./SkuWiseSaleReport";
import StateWiseSaleReport from "./StateWiseSaleReport";
import RegionWiseSaleReport from "./RegionWiseSaleReport";
import CityWiseSaleReport from "./CityWiseSaleReport";
import AreaWiseSalesReport from "./AreaWiseSalesReport";
import CustomerWiseSalesReport from "./CustomerWiseSalesReport";
import CustomerTypeWiseSalesReport from "./CustomerTypeWiseSalesReport";

import { CONFIG } from "common/config";
import { LABELS } from "common/lables";

import "./dashboard.css";
import "./styles/reports.css";
import "./styles/datatables.min.css";
import "devextreme/dist/css/dx.light.css";

const employeeLeavesReport = require("assets/images/reports/employeeleavesreport.png");
const chart1 = require("assets/images/reports/chart1.png");
const chartResourceHistogram = require("assets/images/reports/Resource_Histogram.png");
const chartResourceTable = require("assets/images/reports/Resource_Table.png");
const chartManHoursPlan = require("assets/images/reports/Man_Hours_Distribution.png");
const chartProgressCurve = require("assets/images/reports/Progress_S_Curve.png");
const chartProjectCashFlow = require("assets/images/reports/Project_Cashflow.png");
const chartProgressStatus = require("assets/images/reports/Project_Progress_Pie.png");
const chartProjectOverview = require("assets/images/reports/Project_Overview.png");
const chartRisksRegister = require("assets/images/reports/Risk_Register.png");
const chartEarnedValue = require("assets/images/reports/Earned_Value_Report.png");
const chartQuantitiesReport = require("assets/images/reports/Quantities_Report.png");
const chartManhoursReport = require("assets/images/reports/Manhours_Report.png");
const chartCostReport = require("assets/images/reports/Cost_Report.png");
const chartConstraintLogReport = require("assets/images/reports/Constraint_Log_Report.png");
const chartTimeSheetLog = require("assets/images/reports/Time_Sheet_Log_Report.png");
const chartApprovalLog = require("assets/images/reports/Approval_Log_Report.png");
const userLogreport = require("assets/images/reports/User_Log_Report.png");
const invoicereport = require("assets/images/reports/invoicereport.png");
const analysisReport = require("assets/images/reports/projectsreport.png");

const Reports = (props: any = {}) => {
  const [dashMenu, setDashMenu] = useState(LABELS.HOME);
  const { childRef, userInfo } = props;
  const setMenu = () => {
    setDashMenu(LABELS.HOME);
  };
  childRef.setMenu = setMenu;

  let menuUserLog = false;
  if (userInfo.role.id === CONFIG.USER_ROLES.Admin) {
    menuUserLog = true;
  }

  return (
    <React.Fragment>
      {dashMenu == LABELS.HOME && (
        <div className="userDashboard">
          <div className="pageInfo">
            <ul className="breadcrumbs">
              <li>{LABELS.HOME}</li>
              <li className="dim">{" / "}</li>
              <li className="active">{LABELS.REPORTS}</li>
            </ul>
            <h4>{LABELS.REPORTS}</h4>
          </div>

          <MenuList dense className="dashboardMenuWrap">
            {/* <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.GEO_REPORT);
              }}
            >
              <img src={employeeLeavesReport} />
              <h4>{LABELS.GEO_REPORT}</h4>
            </MenuItem> */}

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.REPORT1);
              }}
            >
              <img src={employeeLeavesReport} />
              <h4>{LABELS.REPORT1}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.CUSTOMER_ORDERS);
              }}
            >
              <img src={chartProjectCashFlow} />
              <h4>{LABELS.CUSTOMER_ORDERS}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.ROUTE_LIST_REPORT);
              }}
            >
              <img src={chartConstraintLogReport} />
              <h4>{LABELS.ROUTE_LIST_REPORT}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.PRICE_LIST_REPORT);
              }}
            >
              <img src={chartQuantitiesReport} />
              <h4>{LABELS.PRICE_LIST_REPORT}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.PRODUCT_LIST_REPORT);
              }}
            >
              <img src={chartQuantitiesReport} />
              <h4>{LABELS.PRODUCT_LIST_REPORT}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.LEADS_REPORT);
              }}
            >
              <img src={chartConstraintLogReport} />
              <h4>{LABELS.LEADS_REPORT}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.FEEDBACK_REPORT);
              }}
            >
              <img src={chartRisksRegister} />
              <h4>{LABELS.FEEDBACK_REPORT}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.INSTRUCTION_REPORT);
              }}
            >
              <img src={chartTimeSheetLog} />
              <h4>{LABELS.INSTRUCTION_REPORT}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.SURVEY_REPORT);
              }}
            >
              <img src={chartRisksRegister} />
              <h4>{LABELS.SURVEY_REPORT}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.CUSTOMER_LIST_REPORT);
              }}
            >
              <img src={chartResourceTable} />
              <h4>{LABELS.CUSTOMER_LIST_REPORT}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.LEAVES_REPORT);
              }}
            >
              <img src={employeeLeavesReport} />
              <h4>{LABELS.LEAVES_REPORT}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.ATTENDANCE_REPORT);
              }}
            >
              <img src={chartTimeSheetLog} />
              <h4>{LABELS.ATTENDANCE_REPORT}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.CITIES_LIST_REPORT);
              }}
            >
              <img src={userLogreport} />
              <h4>{LABELS.CITIES_LIST_REPORT}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.TEAM_DETAIL_REPORT);
              }}
            >
              <img src={chartResourceHistogram} />
              <h4>{LABELS.TEAM_DETAIL_REPORT}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.BEAT_LIST_REPORT);
              }}
            >
              <img src={chartConstraintLogReport} />
              <h4>{LABELS.BEAT_LIST_REPORT}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.BEAT_LOG_REPORT);
              }}
            >
              <img src={chartConstraintLogReport} />
              <h4>{LABELS.BEAT_LOG_REPORT}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.ORDER_DETAIL_REPORT);
              }}
            >
              <img src={chartProjectCashFlow} />
              <h4>{LABELS.ORDER_DETAIL_REPORT}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.SCHEMES_DETAIL_REPORT);
              }}
            >
              <img src={chartEarnedValue} />
              <h4>{LABELS.SCHEMES_DETAIL_REPORT}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.TARGET_DETAIL_REPORT);
              }}
            >
              <img src={invoicereport} />
              <h4>{LABELS.TARGET_DETAIL_REPORT}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.SCHEME_UTILIZATION_REPORT);
              }}
            >
              <img src={chartProgressCurve} />
              <h4>{LABELS.SCHEME_UTILIZATION_REPORT}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.TARGET_ACHIEVED_REPORT);
              }}
            >
              <img src={chartCostReport} />
              <h4>{LABELS.TARGET_ACHIEVED_REPORT}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.TARGET_ACHIEVED_TOTAL_REPORT);
              }}
            >
              <img src={chartCostReport} />
              <h4>{LABELS.TARGET_ACHIEVED_TOTAL_REPORT}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.CATEGORY_WISE_SALES);
              }}
            >
              <img src={analysisReport} />
              <h4>{LABELS.CATEGORY_WISE_SALES}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.MAIN_CATEGORY_WISE_SALES);
              }}
            >
              <img src={analysisReport} />
              <h4>{LABELS.MAIN_CATEGORY_WISE_SALES}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.SUB_CATEGORY_WISE_SALES);
              }}
            >
              <img src={analysisReport} />
              <h4>{LABELS.SUB_CATEGORY_WISE_SALES}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.PRODUCT_WISE_SALES);
              }}
            >
              <img src={analysisReport} />
              <h4>{LABELS.PRODUCT_WISE_SALES}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.STATE_WISE_SALES);
              }}
            >
              <img src={analysisReport} />
              <h4>{LABELS.STATE_WISE_SALES}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.REGION_WISE_SALES);
              }}
            >
              <img src={analysisReport} />
              <h4>{LABELS.REGION_WISE_SALES}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.CITY_WISE_SALES);
              }}
            >
              <img src={analysisReport} />
              <h4>{LABELS.CITY_WISE_SALES}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.AREA_WISE_SALES);
              }}
            >
              <img src={analysisReport} />
              <h4>{LABELS.AREA_WISE_SALES}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.CUSTOMER_WISE_SALES);
              }}
            >
              <img src={analysisReport} />
              <h4>{LABELS.CUSTOMER_WISE_SALES}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.CUSTOMER_TYPE_WISE_SALES);
              }}
            >
              <img src={analysisReport} />
              <h4>{LABELS.CUSTOMER_TYPE_WISE_SALES}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.USER_LOG_REPORT);
              }}
            >
              <img src={employeeLeavesReport} />
              <h4>{LABELS.USER_LOG_REPORT}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.ALL_LOGS_REPORT);
              }}
            >
              <img src={employeeLeavesReport} />
              <h4>{LABELS.ALL_LOGS_REPORT}</h4>
            </MenuItem>
          </MenuList>
        </div>
      )}

      {dashMenu == LABELS.GEO_REPORT && (
        <ReportEmployeeLeaves setDashMenu={setDashMenu} />
      )}

      {dashMenu == LABELS.USER_LOG_REPORT && (
        <UserLogReport setDashMenu={setDashMenu} />
      )}

      {dashMenu == LABELS.REPORT1 && <Report1 setDashMenu={setDashMenu} />}

      {dashMenu == LABELS.CUSTOMER_ORDERS && (
        <CustomerOrders setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.ALL_LOGS_REPORT && (
        <AllLogsReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.ROUTE_LIST_REPORT && (
        <RouteList setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.PRICE_LIST_REPORT && (
        <PriceList setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.PRODUCT_LIST_REPORT && (
        <ProductList setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.LEADS_REPORT && (
        <LeadsReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.FEEDBACK_REPORT && (
        <FeedbackReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.INSTRUCTION_REPORT && (
        <InstructionsReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.SURVEY_REPORT && (
        <SurveyReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.CUSTOMER_LIST_REPORT && (
        <CustomerList setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.LEAVES_REPORT && (
        <LeavesReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.ATTENDANCE_REPORT && (
        <AttendanceReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.CITIES_LIST_REPORT && (
        <CitiesListReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.TEAM_DETAIL_REPORT && (
        <TeamDetailReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.BEAT_LIST_REPORT && (
        <RouteReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.BEAT_LOG_REPORT && (
        <BeatOrderReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.ORDER_DETAIL_REPORT && (
        <OrderDetailReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.SCHEMES_DETAIL_REPORT && (
        <SchemeReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.TARGET_DETAIL_REPORT && (
        <TargetReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.SCHEME_UTILIZATION_REPORT && (
        <SchemeUtilizationReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.TARGET_ACHIEVED_REPORT && (
        <TargetStatusReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.TARGET_ACHIEVED_TOTAL_REPORT && (
        <TargetTotalReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.CATEGORY_WISE_SALES && (
        <CategorySaleReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.MAIN_CATEGORY_WISE_SALES && (
        <MainCategoryWiseSaleReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.SUB_CATEGORY_WISE_SALES && (
        <SubCategoryWiseSaleReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.PRODUCT_WISE_SALES && (
        <SkuWiseSaleReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.STATE_WISE_SALES && (
        <StateWiseSaleReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.REGION_WISE_SALES && (
        <RegionWiseSaleReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.CITY_WISE_SALES && (
        <CityWiseSaleReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.AREA_WISE_SALES && (
        <AreaWiseSalesReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.CUSTOMER_WISE_SALES && (
        <CustomerWiseSalesReport setDashMenu={setDashMenu} />
      )}
      {dashMenu == LABELS.CUSTOMER_TYPE_WISE_SALES && (
        <CustomerTypeWiseSalesReport setDashMenu={setDashMenu} />
      )}
    </React.Fragment>
  );
};

export default Reports;
